// source: dash/v1/lesson_unit.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var dash_v1_models_pb = require('../../dash/v1/models_pb.js');
goog.object.extend(proto, dash_v1_models_pb);
var types_v1_status_pb = require('../../types/v1/status_pb.js');
goog.object.extend(proto, types_v1_status_pb);
goog.exportSymbol('proto.dash.v1.GetLessonUnitRequest', null, global);
goog.exportSymbol('proto.dash.v1.GetLessonUnitResponse', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitsRequest', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitsResponse', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitRequest', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitRequest.displayName = 'proto.dash.v1.GetLessonUnitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.v1.GetLessonUnitResponse.repeatedFields_, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitResponse.displayName = 'proto.dash.v1.GetLessonUnitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonUnitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitRequest.displayName = 'proto.dash.v1.PutLessonUnitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonUnitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitResponse.displayName = 'proto.dash.v1.PutLessonUnitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitsRequest.displayName = 'proto.dash.v1.ListLessonUnitsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.v1.ListLessonUnitsResponse.repeatedFields_, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitsResponse.displayName = 'proto.dash.v1.ListLessonUnitsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitRequest}
 */
proto.dash.v1.GetLessonUnitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitRequest;
  return proto.dash.v1.GetLessonUnitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitRequest}
 */
proto.dash.v1.GetLessonUnitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dash.v1.GetLessonUnitRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.GetLessonUnitRequest} returns this
 */
proto.dash.v1.GetLessonUnitRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.v1.GetLessonUnitResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnit: (f = msg.getLessonUnit()) && dash_v1_models_pb.LessonUnit.toObject(includeInstance, f),
    lessonUnitBooksList: jspb.Message.toObjectList(msg.getLessonUnitBooksList(),
    dash_v1_models_pb.LessonUnitBook.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitResponse}
 */
proto.dash.v1.GetLessonUnitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitResponse;
  return proto.dash.v1.GetLessonUnitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitResponse}
 */
proto.dash.v1.GetLessonUnitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnit;
      reader.readMessage(value,dash_v1_models_pb.LessonUnit.deserializeBinaryFromReader);
      msg.setLessonUnit(value);
      break;
    case 2:
      var value = new dash_v1_models_pb.LessonUnitBook;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitBook.deserializeBinaryFromReader);
      msg.addLessonUnitBooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnit.serializeBinaryToWriter
    );
  }
  f = message.getLessonUnitBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      dash_v1_models_pb.LessonUnitBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnit lesson_unit = 1;
 * @return {?proto.dash.v1.LessonUnit}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.getLessonUnit = function() {
  return /** @type{?proto.dash.v1.LessonUnit} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnit, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnit|undefined} value
 * @return {!proto.dash.v1.GetLessonUnitResponse} returns this
*/
proto.dash.v1.GetLessonUnitResponse.prototype.setLessonUnit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.GetLessonUnitResponse} returns this
 */
proto.dash.v1.GetLessonUnitResponse.prototype.clearLessonUnit = function() {
  return this.setLessonUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.hasLessonUnit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated LessonUnitBook lesson_unit_books = 2;
 * @return {!Array<!proto.dash.v1.LessonUnitBook>}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.getLessonUnitBooksList = function() {
  return /** @type{!Array<!proto.dash.v1.LessonUnitBook>} */ (
    jspb.Message.getRepeatedWrapperField(this, dash_v1_models_pb.LessonUnitBook, 2));
};


/**
 * @param {!Array<!proto.dash.v1.LessonUnitBook>} value
 * @return {!proto.dash.v1.GetLessonUnitResponse} returns this
*/
proto.dash.v1.GetLessonUnitResponse.prototype.setLessonUnitBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.dash.v1.LessonUnitBook=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.v1.LessonUnitBook}
 */
proto.dash.v1.GetLessonUnitResponse.prototype.addLessonUnitBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.dash.v1.LessonUnitBook, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.v1.GetLessonUnitResponse} returns this
 */
proto.dash.v1.GetLessonUnitResponse.prototype.clearLessonUnitBooksList = function() {
  return this.setLessonUnitBooksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnit: (f = msg.getLessonUnit()) && dash_v1_models_pb.LessonUnit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitRequest}
 */
proto.dash.v1.PutLessonUnitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitRequest;
  return proto.dash.v1.PutLessonUnitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitRequest}
 */
proto.dash.v1.PutLessonUnitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnit;
      reader.readMessage(value,dash_v1_models_pb.LessonUnit.deserializeBinaryFromReader);
      msg.setLessonUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnit.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnit lesson_unit = 1;
 * @return {?proto.dash.v1.LessonUnit}
 */
proto.dash.v1.PutLessonUnitRequest.prototype.getLessonUnit = function() {
  return /** @type{?proto.dash.v1.LessonUnit} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnit, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnit|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitRequest} returns this
*/
proto.dash.v1.PutLessonUnitRequest.prototype.setLessonUnit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitRequest} returns this
 */
proto.dash.v1.PutLessonUnitRequest.prototype.clearLessonUnit = function() {
  return this.setLessonUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitRequest.prototype.hasLessonUnit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnit: (f = msg.getLessonUnit()) && dash_v1_models_pb.LessonUnit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitResponse}
 */
proto.dash.v1.PutLessonUnitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitResponse;
  return proto.dash.v1.PutLessonUnitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitResponse}
 */
proto.dash.v1.PutLessonUnitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnit;
      reader.readMessage(value,dash_v1_models_pb.LessonUnit.deserializeBinaryFromReader);
      msg.setLessonUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnit.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnit lesson_unit = 1;
 * @return {?proto.dash.v1.LessonUnit}
 */
proto.dash.v1.PutLessonUnitResponse.prototype.getLessonUnit = function() {
  return /** @type{?proto.dash.v1.LessonUnit} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnit, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnit|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitResponse} returns this
*/
proto.dash.v1.PutLessonUnitResponse.prototype.setLessonUnit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitResponse} returns this
 */
proto.dash.v1.PutLessonUnitResponse.prototype.clearLessonUnit = function() {
  return this.setLessonUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitResponse.prototype.hasLessonUnit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    areaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lessonId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitsRequest}
 */
proto.dash.v1.ListLessonUnitsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitsRequest;
  return proto.dash.v1.ListLessonUnitsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitsRequest}
 */
proto.dash.v1.ListLessonUnitsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAreaId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonId(value);
      break;
    case 3:
      var value = /** @type {!proto.types.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLessonId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 area_id = 1;
 * @return {number}
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.getAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonUnitsRequest} returns this
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.setAreaId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lesson_id = 2;
 * @return {number}
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.getLessonId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonUnitsRequest} returns this
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.setLessonId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional types.v1.Status status = 3;
 * @return {!proto.types.v1.Status}
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.getStatus = function() {
  return /** @type {!proto.types.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.types.v1.Status} value
 * @return {!proto.dash.v1.ListLessonUnitsRequest} returns this
 */
proto.dash.v1.ListLessonUnitsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.v1.ListLessonUnitsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitsList: jspb.Message.toObjectList(msg.getLessonUnitsList(),
    dash_v1_models_pb.LessonUnit.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitsResponse}
 */
proto.dash.v1.ListLessonUnitsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitsResponse;
  return proto.dash.v1.ListLessonUnitsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitsResponse}
 */
proto.dash.v1.ListLessonUnitsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnit;
      reader.readMessage(value,dash_v1_models_pb.LessonUnit.deserializeBinaryFromReader);
      msg.addLessonUnits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnit.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LessonUnit lesson_units = 1;
 * @return {!Array<!proto.dash.v1.LessonUnit>}
 */
proto.dash.v1.ListLessonUnitsResponse.prototype.getLessonUnitsList = function() {
  return /** @type{!Array<!proto.dash.v1.LessonUnit>} */ (
    jspb.Message.getRepeatedWrapperField(this, dash_v1_models_pb.LessonUnit, 1));
};


/**
 * @param {!Array<!proto.dash.v1.LessonUnit>} value
 * @return {!proto.dash.v1.ListLessonUnitsResponse} returns this
*/
proto.dash.v1.ListLessonUnitsResponse.prototype.setLessonUnitsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dash.v1.LessonUnit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.v1.LessonUnit}
 */
proto.dash.v1.ListLessonUnitsResponse.prototype.addLessonUnits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dash.v1.LessonUnit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.v1.ListLessonUnitsResponse} returns this
 */
proto.dash.v1.ListLessonUnitsResponse.prototype.clearLessonUnitsList = function() {
  return this.setLessonUnitsList([]);
};


goog.object.extend(exports, proto.dash.v1);
